import { FC } from "react"
import Img from "./img"
import { appendHost } from "@/const/append";


interface IEmpty {
    children?: string
}

const Empty: FC<IEmpty> = ({ children }) => {
    return (
        <div className="grid align_center justify_center mb20">
            <Img  width={160} height={150} src={appendHost("/images/default/nodata/no-found.png")} />
            <div className="text_center">没数据...</div>
        </div>
    )
}
export default Empty